import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { GrossSalaryChartData } from "models/propTypes/additionalChartData";
//#endregion
//#region components
import { ViewPanel } from "components/common";
import GrossSalaryAdditionalChartData from "../_partials/grossSalaryAdditionalChartData";
import GrossSalaryChart from "./grossSalaryChart";
import { useReportWidgetAdditionalData } from "./useReportWidgetAdditionalData";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GrossSalaryChartWrapper: React.FC = () => {
  const { additionalData: chartData, onChartSuccessHandler } = useReportWidgetAdditionalData<GrossSalaryChartData>();

  return (
    <ViewPanel
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.GrossSalaryChartTitle)}
      appearance="sm"
      gridSize="md"
      isCanvasContent
      additionalContent={
        chartData ? (
          <GrossSalaryAdditionalChartData
            currentTotalYtd={chartData.currentTotalYtd}
            futureTotal={chartData.futureTotal}
          />
        ) : undefined
      }
    >
      <GrossSalaryChart onChartSuccessHandler={onChartSuccessHandler} />
    </ViewPanel>
  );
};

export default GrossSalaryChartWrapper;
